import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

let self: any;

@Injectable({ providedIn: 'root' })
export class HttpService {

  constructor(
    private _http: HttpClient
  ) {
    self = this;
  }

  get(url: string, options?: any): Observable<any> {
    return this._http.get(url, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  post(url: string, body: any, options?: any): Observable<any> {
    return this._http.post(url, body, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  _post(url: string, body: any, options?: any): Observable<any> {
    return this._http.post(url, body, options);
  }

  put(url: string, body: any, options?: any): Observable<any> {
    return this._http.put(url, body, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  patch(url: string, body: any, options?: any): Observable<any> {
    return this._http.patch(url, body, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  delete(url: string, options?: any): Observable<any> {
    return this._http.delete(url, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {

    try {
      if (error.error instanceof ErrorEvent) {
        // A client-side or network error occurred. Handle it accordingly.
        console.error('Ocurrio un error:', error.error.message);
        self.alertService.warn(error.error.message);
      } else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        console.error(
          `Backend retorno el error  ${error.status}, ` +
          `con el cuerpo: ${error.error.message}`);
        self.alertService.error(`${error.error.message}`);
      }
    } catch (e) {
      console.error(error)
    }
    // return an observable with a user-facing error message
    return throwError(
      'Algo no salio bien, Por favor intente de nuevo mas tarde');
  }
}
